import { FieldProps } from './Types'
import { Text } from 'blaze-ui/Text/Text'
import { PropsWithChildren } from 'react'
import Styles from './Field.module.scss'

export const Field = ({ label, icon: Icon, children }: PropsWithChildren<FieldProps>) => (
  <label className={Styles.label}>
    <div className={Styles.name}>
      <Icon size={20} color="var(--dark-40)" />
      <Text variant="secondary" color="var(--dark-40)">
        {label}
      </Text>
    </div>
    <div className={Styles.input}>{children}</div>
  </label>
)
